import { render, staticRenderFns } from "./CrudItem.vue?vue&type=template&id=d36db6f4&scoped=true"
import script from "./CrudItem.vue?vue&type=script&lang=js"
export * from "./CrudItem.vue?vue&type=script&lang=js"
import style0 from "./CrudItem.vue?vue&type=style&index=0&id=d36db6f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36db6f4",
  null
  
)

export default component.exports